import { InMemoryWebStorage, UserManager, WebStorageStateStore } from "oidc-client-ts";

import type { OidcPort } from "./authService";
import type { OidcConfig } from "./config";

/**
 * oidc-client-ts `UserManager` for Keycloak (ADR-0003/D-2): Authorization Code + PKCE (S256, the library default),
 * the **user (tokens) in memory only** — never localStorage/sessionStorage (ADR-0020/D-3). Only the short-lived PKCE
 * request state (code verifier, return path) uses sessionStorage, because it must survive the redirect.
 * Silent renewal uses the rotating refresh token (Keycloak: reuse 0); the iframe page is the fallback.
 */
export function createUserManager(config: OidcConfig): OidcPort {
  const manager: OidcPort = new UserManager({
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: config.redirectUri,
    post_logout_redirect_uri: config.postLogoutRedirectUri,
    silent_redirect_uri: config.silentRedirectUri,
    popup_redirect_uri: config.popupRedirectUri,
    response_type: "code",
    scope: config.scope,
    userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: true,
    loadUserInfo: false,
    monitorSession: false,
    revokeTokenTypes: ["refresh_token"],
    revokeTokensOnSignout: true,
  });
  return manager;
}
